module.exports = __webpack_public_path__ + "media/bootstrap-icons/folder-fill-1372a380.svg";